<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M1.875 14.25h14.25v1.5H1.875v-1.5Zm12.63-2.363a1.13 1.13 0 0 0 1.38-.795 1.132 1.132 0 0 0-.795-1.38l-3.982-1.064-2.07-6.765L7.59 1.5v6.21l-3.728-.997-.697-1.74-1.087-.293v3.877l12.427 3.33Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
